import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface MuiInputControlledProps {
  inputProps: {
    name: string;
    defaultValue?: string;
    label?: string;
    placeholder?: string;
  };
  styles?: any;
}

export function MuiInputControlled({
  inputProps,
  styles = {},
}: MuiInputControlledProps) {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  return (
    <Controller
      control={control}
      name={inputProps.name}
      defaultValue={inputProps.defaultValue ?? ''}
      render={({ field }) => (
        <TextField
          id={inputProps.name}
          label={inputProps.label ?? ''}
          helperText={errors[inputProps.name] ? String(errors[inputProps.name]?.message) : ''}
          variant="outlined"
          placeholder={inputProps.placeholder ?? ''}
          error={!!errors[inputProps.name]}
          {...field}
          {...inputProps}
          sx={styles}
        />
      )}
    />
  );
}
